const PUBLIC_STANDALONE_PATH_PREFIXES = [
  '/consult-intake',
  '/questionnaire',
  '/portal-invite',
  '/organization-invite',
  '/register',
  '/check-email',
  '/verify-email',
  '/sandbox-terms',
  '/sandbox-evaluation-terms',
  '/login',
  '/forgot-password',
  '/reset-password',
];

export function isPublicStandalonePath(pathname = window.location.pathname) {
  return PUBLIC_STANDALONE_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
